<template>
  <div v-if="$store.getters.fullyLoaded">
    <h1 class="title is-1">{{ generator.title }} Generator</h1>
    <b-button
      @click="loadData(true)"
      type="is-success"
    >
      New {{ generator.title.toLowerCase() }}
    </b-button>
    <div class="box" v-if="result">
      <h2 class="subtitle is-2">{{ result.title }}</h2>
      <div class="block">
        <div
          v-for="(t, idx) in text"
          :key="idx"
        >
          {{ t }}
        </div>
      </div>
      <section v-for="(section, idx) in result.sections" :key="`section-${idx}`">
        <b-message :title="section.heading" size="is-small" :closable="false">
          <div
            v-for="(t, idy) in splitText(section.text)"
            :key="`section-${idx}:${idy}`"
            class="block"
          >
            {{ t }}
          </div>
        </b-message>
      </section>
      <h3 class="subtitle is-3">Permalink</h3>
      <div class="columns">
        <div class="column">
          <b-input v-model="link">{{link}}</b-input>
        </div>
        <div class="column">
          <b-button
            type="is-primary"
            v-clipboard:copy="link"
            v-clipboard:success="onCopySuccess"
            v-clipboard:error="onCopyError"
          >
            Copy
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data: () => {
    return {
      seed: null,
      result: null,
      generator: {}
    }
  },
  mounted () {
    this.seed = this.$route.query.seed
    if (this.fullyLoaded) {
      this.loadData(false)
    }
  },
  watch: {
    fullyLoaded (prevState, nextState) {
      this.loadData()
    },
    $route (to, from) {
      this.loadData()
    }
  },
  computed: {
    fullyLoaded: function () {
      return this.$store.getters.fullyLoaded
    },
    text: function () {
      if (!this.result) {
        return []
      } else {
        return this.result.description.split('|')
      }
    },
    link: function () {
      return `https://generators.dezzles-apps.com/${this.$route.params.generator}?seed=${this.seed}`
    }
  },
  methods: {
    loadData: function (newSeed) {
      if (newSeed) {
        this.seed = null
      }
      this.setGenerator()
      let r
      if (this.generator.generator === 'markov') {
        r = this.$store.getters.markov(this.$route.params.generator, this.seed)
      } else {
        r = this.$store.getters.story(this.$route.params.generator, this.seed)
      }
      this.seed = r.seed
      this.result = r.result
    },
    splitText: function (text) {
      if (!text) {
        return []
      } else {
        return text.split('|')
      }
    },
    onCopySuccess: function () {
      this.$buefy.toast.open({
        message: 'Copied!',
        type: 'is-success',
        position: 'is-bottom'
      })
    },
    setGenerator: function () {
      const f = this.$store.getters.generators
        .filter(u => this.$route.params.generator === u.name)
      if (f.length === 0) {
        this.generator = {
          name: 'Unknown Generator'
        }
      } else {
        this.generator = f[0]
      }
    },
    onCopyError: function () {
      this.$buefy.toast.open({
        message: 'Couldn\'t copy :(',
        type: 'is-danger',
        position: 'is-bottom'
      })
    }
  }
}
</script>

<style>

</style>
